
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.016 8.982h3L12 4.023l-5.016 4.96h3v4.023h4.032V8.982zm5.343-2.947c1.282.094 2.375.624 3.282 1.59.906.936 1.359 2.06 1.359 3.37 0 1.372-.5 2.557-1.5 3.555-.969.967-2.14 1.45-3.516 1.45H6c-1.656 0-3.078-.577-4.266-1.731C.578 13.084 0 11.665 0 10.012c0-1.466.516-2.776 1.547-3.93C2.609 4.897 3.875 4.226 5.344 4.07a7.829 7.829 0 012.765-2.947A7.155 7.155 0 0112 0c1.688 0 3.25.593 4.688 1.778 1.468 1.185 2.359 2.604 2.671 4.257z"}})])
          )
        }
      }
    